import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NbDialogRef} from '@nebular/theme';
import moment from 'moment';
import {InvoicingService} from '../../shared/invoicing.service';
import {InvoiceableProject} from '../../interfaces/invoicing';
import {ProjectStatus} from '../../interfaces/project';

/** Picks the period of a new invoice draft, the previous month by default, and the project when none is given (#1518). */
@Component({
  selector: 'bst-new-invoice-dialog',
  templateUrl: './new-invoice-dialog.component.html',
  styleUrls: ['../hours-overview-dialog/hours-overview-dialog.component.scss'],
  styles: ['.project { margin-bottom: 1rem; } .project .label { display: block; }'],
  standalone: false
})
export class NewInvoiceDialogComponent implements OnInit {
  @Input() projectId: number;
  @Input() projectName: string;
  projects: InvoiceableProject[] = null;
  readonly ARCHIVED = ProjectStatus.ARCHIVED;
  form: FormGroup;
  busy = false;

  constructor(protected ref: NbDialogRef<NewInvoiceDialogComponent>, fb: FormBuilder, private invoicing: InvoicingService, private router: Router) {
    // Moments, not Dates: the app's datepicker runs on NbMomentDateModule and cannot show a Date.
    const lastMonth = moment().subtract(1, 'month');
    this.form = fb.group({
      from: [lastMonth.clone().startOf('month'), Validators.required],
      to: [lastMonth.clone().endOf('month'), Validators.required],
    });
  }

  async ngOnInit() {
    if (!this.projectId) {
      this.projects = await this.invoicing.getInvoiceableProjects().catch(() => []);
    }
  }

  get periodValid(): boolean {
    const {from, to} = this.form.value;
    return this.form.valid && !moment(to).isBefore(from, 'day');
  }

  get valid(): boolean {
    return this.periodValid && !!this.projectId;
  }

  async create() {
    if (!this.valid || this.busy) { return; }
    this.busy = true;
    const invoice = await this.invoicing.createInvoice(this.projectId, this.form.value.from, this.form.value.to).catch(() => null);
    this.busy = false;
    if (invoice) {
      this.ref.close();
      this.router.navigate(['/invoices', invoice.id]);
    }
  }

  close() {
    this.ref.close();
  }
}
